var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileGeneric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.442,
    height: 30.849,
    viewBox: "0 0 26.442 30.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_22252",
    "data-name": "Raggruppa 22252",
    transform: "translate(-1281.12 -1243.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-file-pdf",
    "data-name": "Icon metro-file-pdf",
    d: "M27.842,8.745a4.006,4.006,0,0,1,.826,1.308,3.973,3.973,0,0,1,.344,1.515V31.4a1.646,1.646,0,0,1-1.653,1.653H4.223A1.646,1.646,0,0,1,2.571,31.4V3.856A1.646,1.646,0,0,1,4.223,2.2H19.648a3.974,3.974,0,0,1,1.515.344,4.006,4.006,0,0,1,1.308.826ZM20.2,4.545v6.473h6.473A90.629,90.629,0,0,0,20.2,4.545Zm6.61,26.3V13.221H19.648a1.646,1.646,0,0,1-1.653-1.653V4.407H4.774V30.849H26.809Z",
    transform: "translate(1278.549 1241.381)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_5014",
    "data-name": "Linea 5014",
    x2: 13,
    transform: "translate(1287.5 1258.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_5015",
    "data-name": "Linea 5015",
    x2: 13,
    transform: "translate(1287.5 1262.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_5016",
    "data-name": "Linea 5016",
    x2: 8,
    transform: "translate(1287.5 1266.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileGeneric);
export default __webpack_public_path__ + "static/media/file-generic.7391ac47f266213a93346ebf85c552d3.svg";
export { ForwardRef as ReactComponent };